export default __webpack_public_path__ + "static/media/Facebook-Post-940x788px.ff9e90e0.png";